import React from "react";
import useDarkMode from "../../../hooks/useDarkMode";

const FormInput = ({
  label,
  placeHolder,
  type,
  value,
  width = "",
  onchange,
  readOnly,
  icon,
  secIcon,
  name,
  step,
  onclick,
  secIconOnClick,
  iconOnClick,
  iconTitle,
  error,
}) => {
  const isDarkMode = useDarkMode();

  const getFormStyle = () => {
    const invalid = Boolean(error);
    if (isDarkMode) {
      return {
        borderRadius: "10px",
        border: invalid ? "1px solid #e74c3c" : "1px solid #404040",
        background: "#2d3436",
        height: "44px",
        color: "#ffffff",
      };
    }
    return {
      borderRadius: "10px",
      border: invalid ? "1px solid #e74c3c" : "1px solid #D9D9D9",
      background: "#F9F9F9",
      height: "44px",
      color: "#333333",
    };
  };

  return (
    <>
      <label className="form-label" style={{ color: isDarkMode ? "#e0e0e0" : "#495057" }}>{label}</label>
      <div className="position-relative">
        <input
          type={type}
          value={value}
          readOnly={readOnly}
          onChange={onchange}
          onClick={onclick}
          step={step}
          name={name}
          className={`form-control${error ? " is-invalid" : ""}`}
          placeholder={placeHolder}
          style={{
            ...getFormStyle(),
            ...{ width: width },
            ...(icon && { paddingRight: "40px" }),
          }}
        />
        {icon && (
          <i
            className={`fa ${icon}`}
            onClick={iconOnClick}
            role={iconOnClick ? "button" : undefined}
            tabIndex={iconOnClick ? 0 : undefined}
            title={iconTitle}
            onKeyDown={
              iconOnClick
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      iconOnClick(e);
                    }
                  }
                : undefined
            }
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              color: isDarkMode ? "#adb5bd" : "#6c757d",
              cursor: iconOnClick ? "pointer" : "default",
            }}
          ></i>
        )}

        {secIcon && (
          <i
            className={`fa ${secIcon}`}
            onClick={secIconOnClick}
            style={{
              position: "absolute",
              right: "35px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#f03a4f",
              cursor: "pointer", 
            }}
          ></i>
        )}
      </div>
      {error ? (
        <div className="invalid-feedback d-block small mt-1" style={{ color: "#e74c3c" }}>
          {error}
        </div>
      ) : null}
    </>
  );
};

export default FormInput;
